import React, { useState } from 'react';
import { NumberBox, NumberBoxLayoutStyle } from '@apply/components';
import { sectionHeaderStyle } from '../constants/styles';

export const NumberBoxPanel: React.FC = () => {
    // State for each example
    const [basicValue, set_basicValue] = useState(0);
    const [readOnlyValue, set_readOnlyValue] = useState(0);
    const [requiredValue, set_requiredValue] = useState(0);
    const [basicValueWithBubble, set_basicValueWithBubble] = useState(0);
    const [horizontalValue, set_horizontalValue] = useState(0);
    const [horizontalReadOnlyValue, set_horizontalReadOnlyValue] = useState(0);
    const [horizontalRequiredValue, set_horizontalRequiredValue] = useState(0);
    const [horizontalValueWithBubble, set_horizontalValueWithBubble] = useState(0);

    return (
        <>
            {/* Example 1: NumberBox */}
            <div style={{ marginBottom: '1rem' }}>
                <NumberBox
                    value={basicValue}
                    onChange={set_basicValue}
                    label='Basic NumberBox'
                />
            </div>

            {/* Example 2: Read-Only NumberBox */}
            <div style={{ marginBottom: '1rem' }}>
                <NumberBox
                    value={readOnlyValue}
                    onChange={set_readOnlyValue}
                    label='Read-Only NumberBox'
                    readOnly={true}
                />
            </div>

            {/* Example 3: Required Field */}
            <div style={{ marginBottom: '1rem' }}>
                <NumberBox
                    value={requiredValue}
                    onChange={set_requiredValue}
                    label='Required Numberbox'
                    required={true}
                />
            </div>
            {/* Example 4: NumberBox with Info Bubble */}
            <div style={{ marginBottom: '1rem' }}>
                <NumberBox
                    value={basicValueWithBubble}
                    onChange={set_basicValueWithBubble}
                    label='Basic NumberBox'
                    showInfoIcon={true}
                    infoText='Basic NumberBox'
                />
            </div>

            {/* Example 5: NumberBox (Horiz.) */}
            <div style={{ marginBottom: '1rem' }}>
                <NumberBox
                    value={horizontalValue}
                    onChange={set_horizontalValue}
                    label='Basic NumberBox (Horiz.)'
                    layoutStyle={NumberBoxLayoutStyle.Horizontal}
                    labelWidth='210px'
                />
            </div>

            {/* Example 6: Read-Only NumberBox (Horiz.) */}
            <div style={{ marginBottom: '1rem' }}>
                <NumberBox
                    value={horizontalReadOnlyValue}
                    onChange={set_horizontalReadOnlyValue}
                    label='Read-Only NumberBox (Horiz.)'
                    readOnly={true}
                    layoutStyle={NumberBoxLayoutStyle.Horizontal}
                    labelWidth='210px'
                />
            </div>

            {/* Example 7: Required Field (Horiz.) */}
            <div style={{ marginBottom: '1rem' }}>
                <NumberBox
                    value={horizontalRequiredValue}
                    onChange={set_horizontalRequiredValue}
                    label='Required Numberbox (Horiz.)'
                    required={true}
                    layoutStyle={NumberBoxLayoutStyle.Horizontal}
                    labelWidth='210px'
                />
            </div>
            {/* Example 8: NumberBox with Info Bubble (Horiz.) */}
            <div style={{ marginBottom: '1rem' }}>
                <NumberBox
                    value={horizontalValueWithBubble}
                    onChange={set_horizontalValueWithBubble}
                    label='Basic NumberBox (Horiz.)'
                    showInfoIcon={true}
                    infoText='Basic NumberBox'
                    layoutStyle={NumberBoxLayoutStyle.Horizontal}
                    labelWidth='210px'
                />
            </div>
        </>
    );
};
